__turbopack_context__.v({
  "arrow": "bFfkDG_arrow",
  "card": "bFfkDG_card",
  "eyebrow": "bFfkDG_eyebrow",
  "image": "bFfkDG_image",
  "imageWrap": "bFfkDG_imageWrap",
  "inner": "bFfkDG_inner",
  "label": "bFfkDG_label",
  "next": "bFfkDG_next",
  "panel": "bFfkDG_panel",
  "placeholder": "bFfkDG_placeholder",
  "prev": "bFfkDG_prev",
  "rail": "bFfkDG_rail",
  "row": "bFfkDG_row",
  "subtitle": "bFfkDG_subtitle",
  "thumb": "bFfkDG_thumb",
  "track": "bFfkDG_track",
});
